import Nanobus from "nanobus";
// @ts-ignore
import $ from 'jquery';
export var initWidthSetting = function (column) {
    column.getElement().querySelectorAll('table[data-setting="width"]').forEach(function (setting) { return new WidthSetting(column, setting); });
};
var WidthSetting = /** @class */ (function () {
    function WidthSetting(column, setting) {
        this.column = column;
        this.setting = setting;
        this.events = new Nanobus();
        this.indicator = new WidthIndicator(column.getElement().querySelector('.ac-column-header .ac-column-heading-setting--width'));
        this.widthInput = this.setting.querySelector('[data-width-input]');
        this.unitInput = this.setting.querySelectorAll('[data-unit-input] input');
        this.init();
    }
    WidthSetting.prototype.getWidth = function () {
        var widthValue = this.widthInput.value;
        return widthValue ? parseInt(widthValue) : null;
    };
    WidthSetting.prototype.setWidth = function (width) {
        this.widthInput.value = width ? width.toString() : null;
        this.updateIndicator();
    };
    WidthSetting.prototype.updateUnit = function () {
        this.setting.querySelector('.description .unit').innerHTML = this.getUnit();
    };
    WidthSetting.prototype.getUnit = function () {
        var input = this.setting.querySelector('[data-unit-input] input:checked');
        return input ? input.value : null;
    };
    WidthSetting.prototype.getValue = function () {
        return {
            width: this.getWidth(),
            unit: this.getUnit()
        };
    };
    WidthSetting.prototype.validate = function () {
        var width = this.getWidth();
        if (width === 0 || width < 0) {
            this.setWidth(null);
        }
        if (this.getUnit() === '%') {
            if (width > 100) {
                this.setWidth(100);
            }
        }
    };
    WidthSetting.prototype.init = function () {
        var _this = this;
        this.widthInput.addEventListener('keyup', function () {
            _this.updateIndicator();
            _this.initSlider();
            _this.validate();
        });
        this.unitInput.forEach(function (el) {
            el.addEventListener('change', function () {
                _this.initSlider();
                _this.updateIndicator();
                _this.updateUnit();
                _this.validate();
            });
        });
        this.initSlider();
    };
    WidthSetting.prototype.updateIndicator = function () {
        this.indicator.setValue(this.getWidth(), this.getUnit());
    };
    WidthSetting.prototype.initSlider = function () {
        var _this = this;
        var sliderElement = this.column.getElement().querySelector('.width-slider');
        $(sliderElement).slider({
            range: 'min',
            min: 0,
            max: '%' === this.getUnit() ? 100 : 500,
            value: this.getWidth(),
            slide: function (event, ui) {
                _this.setWidth(ui.value);
            }
        });
    };
    return WidthSetting;
}());
var WidthIndicator = /** @class */ (function () {
    function WidthIndicator(element) {
        this.element = element;
        this.events = new Nanobus();
    }
    WidthIndicator.prototype.setValue = function (width, unit) {
        if (width === null) {
            return this.element.innerText = '';
        }
        this.element.innerText = "" + width.toString() + unit;
    };
    return WidthIndicator;
}());
